// Wish list bundle — used wherever the "Add to wish list" widget is rendered
// (regular product pages, CMS pages with the {product-wish-list} shortcode,
// and the New Releases details modal).
import '../css/pages/catalog/product/wish-list.css';

import { runLegacy } from './helpers/load-legacy';
import productAddWidgetJs from '../js/pages/user/account/product-add-widget.js?legacy';

runLegacy(
    productAddWidgetJs,
);
